import { qualifyUrl } from "util/URLUtils";
import fetch, { fetchPeriodically } from "logic/rest/FetchProvider";
export const createPublicNotification = (notification) => {
  const url = qualifyUrl("/plugins/org.graylog.plugins.customization/notifications");
  return fetch("POST", url, notification);
};
export const updatePublicNotification = ({
  id,
  notification
}) => {
  const url = qualifyUrl(`/plugins/org.graylog.plugins.customization/notifications/${id}`);
  return fetch("PUT", url, notification);
};
export const deletePublicNotification = (id) => {
  const url = qualifyUrl(`/plugins/org.graylog.plugins.customization/notifications/${id}`);
  return fetch("DELETE", url);
};
export const fetchPublicNotifications = () => {
  const url = qualifyUrl("/plugins/org.graylog.plugins.customization/notifications");
  return fetchPeriodically("GET", url);
};
